angular
.module('logbook')
.directive('userSelectorAjs', ['$timeout', '$http', '$q', function($timeout, $http, $q)
{
	return {

		restrict: 'E',
		template: require('./user-selector.html'),

		scope: {
			onBind: '=',
			selectedLog: '='
		},

		link: function(scope, element, attributes)
		{
			var userSelectedListeners = [];

			scope.allUsers = [];
			scope.filteredUsers = [];

			/**
			 * Retrieves and sets the logUsers of the scope
			 * @return {Promise}
			 */
			scope.fetchUsers = function()
			{
				if (!(scope.selectedLog && !isNaN(scope.selectedLog.id)))
					return;

				return $http.get('api/logUsers?log=' + scope.selectedLog.id)
					.then(function(results)
					{
						scope.allUsers = results.data._embedded.logUsers;
						return scope.copyUsers();
					})
			};

			scope.copyUsers = function()
			{
				return JSON.parse(JSON.stringify(scope.allUsers))
			};

			/**
			 * Filters scope.allUsers and applies the filtering to scope.filteredUsers
			 * @param {boolean=} fetchUsers - Whether a new set of users should be fetched for scope.selectedLog
			 * @param {string=} search - Filters the returned list of names based of the name for first and last name.
			 *
			 * @return {Promise}
			 */
			scope.filterUsers = function(fetchUsers, search)
			{
				search = (typeof search === 'string') ? search.toLowerCase() : undefined;
				return ((fetchUsers) ? scope.fetchUsers() : $q(function(resolve) { resolve(scope.copyUsers()); } ))
					.then(function(users)
					{
						return $timeout(function()
						{
							var filtered = (typeof scope.filter === 'function')
								? scope.filteredUsers = users.filter(scope.filter)
								: users;

							scope.filteredUsers = (typeof search === 'string')
								? filtered.filter(function(user)
								{
									return (
										user.user.firstName.toLowerCase().includes(search) ||
										user.user.lastName.toLowerCase().includes(search)
									)
								})
								: filtered;

						})
					})
			};
			
			/**
			 * Shortcut for calling filterUsers with the search field input passed as the search
			 * @param {Boolean} fetchUsers
			 * @return {Promise}
			 */
			scope.filterUsersFromSearch = function(fetchUsers)
			{
				return scope.filterUsers(fetchUsers, scope.getCurrentText());
			};

			scope.toggleCollapse = function($event, selector, isCollapsed)
			{
				var command = (isCollapsed === true)
					? 'hide'
					: (isCollapsed === false) ? 'show' : 'toggle';

				$(element).find(selector).collapse(command);
			};

			/**
			 * Sets the filter for the context
			 * @param filter
			 */
			scope.setFilter = function(filter)
			{
				if (typeof filter === 'function')
					scope.filter = filter;
				scope.filterUsersFromSearch(false);
				return scope;
			};

			/**
			 * Sets innerHTML of the button used to toggle the selector
			 * @param {string} innerHTML
			 */
			scope.setButtonInnerHtml = function(innerHTML)
			{
				$(element).find('#btn-toggle-selector').html(innerHTML);
				return scope;
			};

			/**
			 * Sets a callback for when a user is selected from this context
			 * @param {function} callback
			 */
			scope.addOnUserSelectedListener = function(callback)
			{
				if (typeof callback === 'function')
					userSelectedListeners.push(callback);
				return scope;
			};

			scope.selectUser = function(user)
			{
				userSelectedListeners.forEach(function(callback) { callback(user) });
				$(element).find('#input-search-users').val('');
				scope.filterUsers(false);
			};



			scope.filterUsers(true).then(function()
			{
				if (typeof scope.onBind === 'function')
					scope.onBind(scope);
			});
			
			scope.getCurrentText = function()
			{
				return $(element).find('#input-search-users').val();
			};
			

			$(element).find('#input-search-users').on('input', function()
			{
				scope.filterUsers(false, $(this).val())
			});

		}

	}
}]);
